<template>
    <component :is="tag">
        <slot
            :step="step"
            :brief="brief"
            :go-next-step="goNextStep"
            :go-previous-step="goPreviousStep"
            :isLoading="isLoading"
            :is-completing-brief="isCompletingBrief"
        />
    </component>
</template>
<script>
    import BaseActivationBriefStepMixin from "../mixins/BaseActivationBriefStepMixin";
    import {NAME_BRAND_ASSETS} from "../../../constants/activation-brief-steps";

    export default {
        name: 'ActivationBriefAssetsProvider',
        mixins: [
            BaseActivationBriefStepMixin,
        ],
        computed: {
            step(){
                return this.steps[NAME_BRAND_ASSETS];
            },
        },
        created() {
            this.isLoading = true;

            this.loadContact()
                .then(() => {
                    return Promise.all([
                        this.loadActivationBrief(),
                    ]);
                })
                .then(() => {
                    this.initStep(this.step);
                })
                .catch(error => this.handleHttpError(error))
                .then(() => {
                    this.isLoading = false;
                });
        }
    }
</script>
